module.exports = __webpack_public_path__ + "img/santander--alt.55a02f06.svg";